// extracted by mini-css-extract-plugin
export default {"valueBlock":"statistic_valueBlock__-aL0p"};